import { string } from 'prop-types';
import classnames from 'classnames';
import React, { Component, Fragment } from 'react';
import styles from './styles';

const SCRIPT_SRC = 'https://www.chicoryapp.com/widget_v2?host=998';

// This code is provided by Chicory. It could be rewritten or modified, however
// it has been left as is to keep our implementation as close to "standard" as
// possible for now...
/* eslint-disable */
/* prettier-ignore */
function _init(w, d, s, n, u, a, m) {
  w['ChicoryObject'] = n;
  w[n] = w[n] || function() {(w[n].q = w[n].q || []).push(arguments)},
  w[n].l = 1 * new Date();
  a = d.createElement(s),
  m = d.getElementsByTagName(s)[0];
  a.async = 1;
  a.src = u;
  m.parentNode.insertBefore(a, m)
}
/* eslint-enable */

class Chicory extends Component {
  componentDidMount() {
    if (!window.chicory) {
      // Load Chicory script once
      _init(window, document, 'script', 'chicory', SCRIPT_SRC);
    }
    // Register page
    window.chicory('setRecipe', this.props.canonical);
  }
  render() {
    const { modifier } = this.props;
    const classes = classnames('chicory-order-ingredients', {
      [`chicory-order-ingredients--${modifier}`]: !!modifier
    });
    return (
      <Fragment>
        <div className={classes} />
        <style jsx>{styles}</style>
      </Fragment>
    );
  }
}

Chicory.defaultProps = {
  modifier: ''
};

Chicory.propTypes = {
  canonical: string.isRequired,
  modifier: string
};

export default Chicory;
